import React from 'react';

import Logo from '../../assets/svg/logo.svg';
import Computer from '../../assets/svg/computer.svg';
import './styles.scss';
import { ReactComponent as Moon } from '../../assets/svg/moon.svg';
import { ReactComponent as Wave } from './wave.svg';
import { ReactComponent as Burger } from '../../assets/svg/menu.svg';
import { toggleTheme, getTheme } from '../../utils';
import { useState } from 'react';

export default function Home() {

    const [menu, setMenu] = useState(false);
    const [theme, setTheme] = useState(getTheme());

    function toggleMenu() {
        setMenu(!menu);
        
        document.body.classList.toggle("stop-scrolling");
    }

    function switchTheme() {
        toggleTheme();
        setTheme(getTheme());
        window.dispatchEvent(new Event("render"));
    }

    return <div className="section home">
    
        <img className="logo" src={Logo}/>
        
        <a className="theme-switch" onClick={switchTheme}>
            <Moon fill={theme === "dark" ? "#fff" : "transparent"}/>
        </a>

        <a onClick={toggleMenu} className="menu-burger">
            <Burger/>
        </a>

        <div className={["menu-container", menu ? "active" : ""].join(" ")} >
            <div className="menu">
                <a href="">Home</a>
                <a href="https://docs.scatteredcorp.tech" target="_blank">Docs</a>
                <a href="https://docs.scatteredcorp.tech/#/wallet" target="_blank">Protocol</a>
                <a href="https://docs.scatteredcorp.tech/#/" className="button">
                    Get started
                </a>
            </div>
        </div>

        <div className="sections">
            <div className="left slide-bottom delay">
                <h1>Scattered Corp</h1>
                <p>BilleGateCoin is a distributed, open-source, secure gaming plateform for the <a target="_blank" href="https://simple.wikipedia.org/wiki/Marbles_(game)">Marble Game</a> powered by the Blockchain technology.</p>
                <div style={{marginTop: 25}}>
                    <a href="https://github.com/scatteredcorp/game/releases/download/1.0.0/BilleGateCoin.exe" className="button">
                        Download
                    </a>
                </div>
            </div>

            <div className="right">
                <img src={Computer} className="computer slide-bottom"/>
            </div>

            <Wave className="wave"/>
            
        </div>

    </div>
}